// The answer-validation 400 from PATCH /applications/regenerate/{id}/{index}:
// the server checked the answer against the question's own options and rejected
// it (app/utils/application_utils.py). Typed rather than told apart by its text
// so the edit panel can both show the server's message — it names the options,
// which is the only clue the user has about what to change — and drop the "try
// again later" advice, since resubmitting the same selections fails identically.

export class AnswerValidationError extends Error {
  // A member of its own, so the class is distinct structurally as well as at
  // runtime: with only Error's fields, narrowing it out of an Error-typed value
  // leaves `never` and the guard below cannot be used in an early return.
  readonly answerValidation = true

  constructor(message: string) {
    super(message)
    this.name = 'AnswerValidationError'
  }
}

export function isAnswerValidationError(
  error: unknown,
): error is AnswerValidationError {
  return error instanceof AnswerValidationError
}
